module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "أبريل-2008-سيدني-مدرسة_الفان_-الخاصة_العالمية"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("#أبريل 2008 #سيدني #مدرسة_الفان_")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الخاصَّة_العالميَّة")])]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "width": "2.97917in",
      "height": "0.36041in"
    },
    attrs: {
      "alt": " ",
      "src": "media/file1.png"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم تكنِ الشَّمس قد أشرقَت تمامًا بعد على ذاك المبنَى الضخمِ العتيق الواقفِ بشموخٍ على أحد تلالِ سيدني منذ خمسين عامًا مضَت، وفي عليَّة ذاك المبنى المسمَّى بمدرسة الفان، تحديدًا في الجزء الشرقي منها تحت ظلال المنارةِ الدَّاكنة، حيث السقفَ المثلَّث والنَّوافذ الكبيرةُ التي تتيحُ لك رؤية مدينة سيدني بأكملها، فتًى ذو زيٍّ مدرسيٍّ داكن أنيق، يرتدي سمَّاعاتِ أذنٍ حمراء كبيرةً نوعًا ما، يتمايلُ جسده على نوعه المفضَّلِ مِن موسيقى الرُّوك، وهو يحاول اصطياد حشرةٍ معلَّقة على السقف بواسطة مكنسةٍ يدويَّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هو تذمَّر عابسًا مئات المرَّات كون الحشرة تأبى الابتعادَ أو العبور مِن النافذة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline !important"
    }
  }, [_vm._v("إلهي.. لِمَ هي صعبة المنال كما هو الحال مع إيلي؟!")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("-أنتِ أيَّتُها الحشرة، احترِمي خصوصيَّات البشر واخرجي مِن هنا، وإلَّا...!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("زامَن حديثه الساخط صوت سقوط هاتفه أرضًا ليعمَّ صمتٌ ثقيلٌ جرَّاء توقُّف الموسيقى عن العمل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أسرع يجثو بجوار هاتفه يتفقَّده في قلقٍ متجاهِلًا المكنسة التي سقطَت بجواره في إهمال، تنفَّس الصُّعداء بعدَها ليجلسَ القرفصاء على الأرض الباردة، وتبدأ أصابعه بمراسلة صديقه:")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9pt",
      "padding": "5px 00"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اليوم 9 مايو 2008")])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هيه مارك، الوقتُ مبكِّرٌ جدًّا للمراسلة، أعلم!")])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("6:46")])])]), _vm._v(" "), _c('ul', {
    staticClass: "list",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('li', [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ولكن أنا أشعرُ بالملل.")])])])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وهناكَ حشرةٌ لعِينةٌ ملتصقةٌ بسقف المنارة تزاحمُ خلوتي!")])])])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هناك شقٌّ غبيٌّ على زجاج هاتفي الجديد!")])])])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وإيلي لا تجيب على مكالماتي منذ يومين!")])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("6:47")])])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنقِذني!")])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("6:48")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أعاد رأسَه إلى الخلف موجِّهًا نظره إلى الأعلى، حيثُ الحشرة التي كانت تبتسمُ له في سخريةٍ.. هكذا ظنَّ هو!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هاتفُه اهتزَّ معلِنًا وصولَ رسالةٍ جديدةٍ.")])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أيُّها الأحمقُ! أظنُّك مَن تزاحمُ خلوةَ تلك الحشرة الضعيفة، أراهنُ أنَّها وصلَت قبلَك إلى المكان؛ لذا فالأحرى بكَ أن تحترمَ خصوصيَّتها!")])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مقروء 6:59")])])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمَّا عن شقِّ هاتفك الغبيّ، فأنتَ تعلمُ أنَّك تستطيع شراء العلامة التجاريَّة لهاتفك باتِّصال واحدٍ!")])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مقروء 7:00")])])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وعوضًا عن إنقاذِك، دعني ألقِّنكَ درسًا يبدِّد شعورَك بالملل، إلى ملعبِ كرةِ السلَّة جاك!")])])])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('em', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنا في الطَّريق إلى هناك بالفعل."), _c('br')])])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- رائعٌ! هكذا أستطيع افتتاح اليومِ الأوَّل للسنةِ الأخيرة في هذا الجحيم بنجاحٍ!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صرخَ بها في عبثٍ وهو يقفزُ واقفًا في رشاقة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حشرَ هاتفه في جيب بنطاله الخلفيّ ليُسرعَ الخُطَى إلى الأسفل عابرًا الدَّهاليز الضيِّقة المؤدِّيةَ إلى المدخل الرئيس للمدرسة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("باحةُ المدرسة الواسعة كانت قد تلوَّنت باللَّون البرتقاليّ الخريفيّ، الطلَّاب بدؤوا بالتوافُد عبر البوَّابةِ الواسعة لتعلُوَ أصواتهم محدِثةً الضَّجيج الصباحي المعتاد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بغضبٍ هسهسَ جاكسون حين أحسَّ بجسده يرتطمُ بقوَّة بأحد الطلاب أثناء جريِه إلى الملعب:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنتَ أيُّها الأعمى! ألا ترى أما...")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بترَ عبارته حين التفتَ إلى ذلك الجسد الضئيلِ والوجه الدائريِّ ذي الشَّعر القصير:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("-أوه.. دو! كيف حالُك يا فتى؟! إلى أين تذهب؟ فصلُك مِن الجهة المقابلةِ، أليس كذلك؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عقدَ دومينيك ساعدَيه محتضِنًا دفتر ملاحظاته إلى صدرِه وكأنَّه يحتمي به في خوفٍ:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- صبا.. صباحُ الخير جاكسون، أنا.. أنا ذاهب لرؤية أمبر.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عبثَ الأطوَلُ بشَعر الفتى ملتفتًا إلى مارك الذي كان يشيرُ إليه أن يسرع في اللحاق به، رمى بسترته على الأرض بجوارِ سترة مارك لتحتضنَ راحةُ يده اليُمنى الكرةَ الموجَّهةَ إليه مِن رفيقه بمهارةٍ.")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- قلتَ إنَّك تريد أن تلقِّنني درسًا ها!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قالها في تحدٍّ وهو يضرب بالكرة الأرض لترتدَّ وتعبرَ معه متَّجهةً إلى السلَّة أمامَهُ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ارتقى بذراعه شادًّا جسده إلى الأعلى موجِّهًا الكرة نحو السلَّة، إلَّا إنَّها لَم تحتضِن شباكها كما أراد!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أناملُ طويلةٌ انتشلَت الكرة قبل عبورِها بخفَّةٍ ومهارةٍ أثارت إعجاب جاكسون نفسه.")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أَتُسمِّي هذا لعبًا يا صاح؟! عليك بذلُ جهدٍ أكبر أمامي!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قالها مارك ساخرًا وهو يحاول تمرير الكرة مِن أمام جاكسون الذي كانَ يجاريه بحركاتٍ مدروسةٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الجميع في هذه المدرسة يعلمُ جيِّدًا أنَّهما الأفضل في فريق كرة السلَّة المدرسي مِن دون منازع، هيكلُ جسدَيهما الطويل، والبنية القويَّة التي يتمتَّعان بها تزيدُهما إثارةً على ما يتمتَّعان به مِن وسامةٍ تثيرُ جنون طالبات المدرسة جميعهنَّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم يستمرَّ النِّزال بينهما طويلًا، استطاعَ مارك المرور مِن أمام خصمِه والعبور نحو الهدفِ، إلَّا إنَّه توقَّف فجأةً حين لَم يلاحظ أيَّ حركة مِن الآخَر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("التفتَ ليجدَه متسمِّرًا في مكانه، ويحدِّقُ نحو مكانٍ ما في هيامٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline !important"
    }
  }, [_vm._v("تبًّا، إنَّها إيلي مجدَّدًا.")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يااااه! أنتَ لن تجعلني أكملُ اللَّعب بمفردي، صحيح؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هتفَ به وهو يرمي بالكرة لترتطمَ بكتف جاك في قوَّة، وترتدُّ مجدَّدًا مِن غير أي ردَّة فعلٍ تُذكَرُ مِن الأخير.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فقط عيناه كانتا تتبعان ذلك الجسد المليء بالانحناءات المثيرةِ والشَّعر الكستنائي المنعقد كذيل حصان والمنسدل إلى الخلف.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline !important"
    }
  }, [_vm._v("الرَّحمة يا إلهي! إنَّها تجعل يسار صدري ينبضُ بقوَّة!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("التقطَ إحدى الستراتِ ليركضَ خلفها متَّجِهًا إلى الفصل، متجاهلًا صديقه الذي هتف غاضبًا وهو يرفع السترة الأخرى عاليًا:")])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- إنَّها سترتي أيُّها الوغد! ألا تعرف كيف تقرأ اسمك المكتوب على ياقتها؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلَّا إنَّه أخيرًا تنهَّد مسبِلًا يديه، متَّجِهًا نحو الفصل بخطواتٍ أقلَّ ما يمكنُ وصفها بالبطيئة جدًّا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a49197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 81
// module chunks = 0